<h2 class="dialog-header paramount-font-class xx-large" style="color: white;padding: 18px 20px">Internal User
    Registration</h2>

<form *ngIf="!loading" [formGroup]="registrationForm" class="reg-form" (ngsubmit)="onSubmit()">
    <mat-dialog-content class="dialog-content">

        <div class="modal-loading" *ngIf="loading">
            <mat-spinner diameter="40"></mat-spinner>
            <div class="loading-text" style="color: white;">Loading…</div>
        </div>

        <mat-grid-list cols="12" rowHeight="82px" gutterSize="8" style=" margin-bottom: 20px;">
            <!-- <mat-grid-tile [colspan]="12"> -->
            <!-- <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                <mat-label>Viacom Domain and User ID (ex: mtvn\userid):</mat-label>
                <input matInput formControlName="userId"
                    placeholder="Viacom Domain and User ID (ex: mtvn\userid):">
                <mat-error style="color: red !important;"
                    *ngIf="registrationForm.get('userId')?.hasError('required')">Required</mat-error>
                <mat-error style="color: red !important;"
                    *ngIf="registrationForm.get('userId')?.errors?.pattern">Only back slash ('\')
                    allowed</mat-error>
            </mat-form-field> -->
            <!-- </mat-grid-tile> -->
            <mat-grid-tile [colspan]="6">
                <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                    <mat-label>First Name:</mat-label>
                    <input matInput formControlName="firstName" maxlength="60" placeholder="First Name:">
                    <mat-hint style="color: white!important;" align="end">{{
                        registrationForm.get('firstName')?.value?.length || 0 }}/30</mat-hint>

                    <mat-error style="color: red !important;"
                        *ngIf="registrationForm.get('firstName')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="6">
                <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                    <mat-label>Last Name:</mat-label>
                    <input matInput formControlName="lastName" maxlength="60" placeholder="Last Name:">

                    <mat-hint style="color: white!important;" align="end">{{
                        registrationForm.get('lastName')?.value?.length || 0 }}/30</mat-hint><mat-error
                        style="color: red !important;"
                        *ngIf="registrationForm.get('lastName')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="12">
                <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                    <mat-label>Email:</mat-label>
                    <input matInput formControlName="email" placeholder="user@company.com">
                    <mat-error class="error" style="color: red !important;"
                        *ngIf="registrationForm.get('email')?.hasError('required')">Required</mat-error>
                    <mat-error class="error" style="color: red !important;"
                        *ngIf="registrationForm.get('email')?.hasError('email')">Invalid email</mat-error>
                    <mat-error class="error" style="color: red !important;"
                        *ngIf="registrationForm.get('email')?.hasError('emailTaken')">{{emailTakenInfo?.message}}</mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="12">
                <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                    <mat-label>Manager's Email:</mat-label>
                    <input matInput formControlName="managerEmail" placeholder="Manager's Email:">
                    <mat-error style="color: red !important;"
                        *ngIf="registrationForm.get('managerEmail')?.hasError('required')">Required</mat-error>
                    <mat-error class="error" style="color: red !important;"
                        *ngIf="registrationForm.get('managerEmail')?.hasError('email')">Invalid
                        email</mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="12">
                <mat-form-field appearance="outline" class="full" style="width:100%;margin-top:2%">
                    <mat-label>Mirror Account:</mat-label>
                    <input matInput formControlName="mirrorAccount" placeholder="Mirror Account:">
                    <mat-hint style="color: white!important">Enter the user ID or name of someone who has
                        the exact same access that you should have</mat-hint>
                    <mat-error style="color: red !important;"
                        *ngIf="registrationForm.get('mirrorAccount')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="12" rowspan="3.5">

                <!-- App Access (static 5, multiselect, at least one required) -->
                <div class="group full">
                    <label class="group-label" style="color: white;">Request System Access</label>
                    <div class="apps">
                        <mat-checkbox color="white" style="border-color: white; color: white!important"
                            *ngFor="let opt of visibleAppOptions; index as i" [checked]="appAccessFA.at(i).value"
                            (change)="appCheckedChanged(i, $event.checked)">
                            <span class="app-label">{{ opt.Key }}</span>
                        </mat-checkbox>
                    </div>
                    <div class="error application-error" *ngIf="appAccessFA.errors?.oneRequired">Select at
                        least one app</div>

                    <p style="color:red !important;" class="peak-sans-regular">
                        <b class="peak-sans-regular">**Note:</b> If the user needs access to License Maestro, please
                        ALSO <a [href]="licenseMaestroFormUrl" class="peak-sans-regular" style="color:white !important"
                            target="_blank">click the
                            link
                            here</a>
                        and fill out this form at MyParamount!
                    </p>

                    <!-- <div
                        *ngIf="registrationForm.controls['userType'].value?.toLowerCase() === userTypeEnum.internal.toLowerCase()">
                        </div> -->
                </div>
                <!-- <div formArrayName="appAccess">
                <label class="form-label">Request System
                    Access:</label>
                <section class="example-section" style="margin-top:5px">
                    <span class="example-list-section">
                        <ul>
                            @for (controls of appAccess.controls; track $index; let i = $index ) {
                            <li [formGroupName]="i">
                                <mat-checkbox
                                    formControlName="isSelected">{{controls.get('name')?.value}}</mat-checkbox>
                            </li>
                            }
                        </ul>
                    </span>
                </section>
            </div> -->
            </mat-grid-tile>
            <!-- <mat-grid-tile [colspan]="12">

            <div class="full" style="width:100%; display: flex; align-items: center; gap: 5%;">
                <label class="mat-body-2">Select Captcha:</label>

                <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()"
                    (expire)="handleExpire()" (load)="handleLoad()" (success)="handleSuccess($event)"
                    [useGlobalDomain]="false" formControlName="recaptcha">
                </ngx-recaptcha2>
            </div>
        </mat-grid-tile> -->
        </mat-grid-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-footer">
        <button mat-button style="color: white!important ;background-color: rgba(0, 0, 0, 0)!important"
            (click)="onCancel()">Cancel</button>
        <button matButton="filled" mat-raised-button style="color: white; background-color: #0046cc; "
            [ngStyle]="{'color: white; background-color: #0046cc;':registrationForm.valid}" (click)="onSubmit()"
            class="cp-btn-submit" type="submit" [disabled]="!registrationForm.valid">Submit</button>


        <!-- <button mat-raised-button style="color: white; background-color: #0046cc;" (click)="onSave()"
            [disabled]="!registrationForm.valid">Continue</button>
        <button mat-button (click)="onCancel()" style="color: white;">Cancel</button> -->
    </mat-dialog-actions>

</form>